export default {
  title: 'Что-то пошло не так',
  text: 'Система пока не может обработать ваш запрос, но не волнуйтесь, мы скоро все починим',
  checkNetworkConnect:
    'Пожалуйста проверьте ваше соединение с сетью и попробуйте обновить страницу',
  hint: 'Попробуйте зайти чуть позже или перейдите на главную',
  refreshPage: 'Обновить страницу',
};
